/**
 * @typedef RecaptchaWrapper
 * @property {function(): string} getResponse
 * @property {function} reset
 */


/**
 * @param {any} grecaptcha Global `window.grecaptcha` object
 * @param {boolean} isEnabled
 * @param {string} siteKey
 * @param {string} selector
 * @returns {RecaptchaWrapper}
 */
function createRecaptchaWrapper(grecaptcha, isEnabled, siteKey, selector = '.g-recaptcha') {
  if (!isEnabled) {
    return {
      getResponse: () => '',
      reset: () => { },
    };
  }

  const $el = document.querySelector(selector);

  const id = grecaptcha.render($el, {
    sitekey: siteKey,
  });

  return {
    getResponse: () => grecaptcha.getResponse(id),
    reset: () => grecaptcha.reset(id),
  };
}

export default createRecaptchaWrapper;



// WEBPACK FOOTER //
// ./src/onePageGiving/createRecaptchaWrapper.js